module.exports = __webpack_public_path__ + "static/media/blogger.d036105e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blogger.png
// module id = 61
// module chunks = 0